/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import OnboardingModuleRenderer from 'bundles/unified-career-academy/module-renderers/OnboardingModuleRenderer';

const styles = {
  onboardingContainer: css`
    margin-top: var(--cds-spacing-800);
    margin-bottom: -40px;
    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-600);
    }
    ${breakpoints.down('xs')} {
      margin-top: var(--cds-spacing-400);
    }
  `,
};

const OnboardingModule = () => {
  return (
    <div css={styles.onboardingContainer}>
      <OnboardingModuleRenderer />
    </div>
  );
};

export default OnboardingModule;
